import { Component, OnInit, ViewChild, ChangeDetectorRef, NgZone, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { OpportunitiesService } from '../../../services/opportunitiesPage/opportunities.service';
import { Opportunities, OpportunityDataRow } from '../../../services/opportunitiesPage/opportunities';

import { SectorsService, sectorslist } from '../../../shared/services/sectors.service';
import { StatusService, statuslist } from '../../../shared/services/status.service';
import { CategoriesService, Categorieslist } from '../../../shared/services/categories.service';
import { Table, TableModule } from 'primeng/table';
import { Message } from 'primeng/api/message';
import { ConfirmationService, PrimeNGConfig, TableState } from 'primeng/api';
import { Source, SourceService } from 'src/app/shared/services/source.service';
import { SalesService, Users } from 'src/app/shared/services/sales.service';
// import { FilterUtils } from "primeng/utils";
import { CloseOpportunityComponent } from './close-opportunity/close-opportunity.component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { saveAs } from 'file-saver';

import * as $ from 'jquery';
import { FilterService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { AccessLevelEnum, AuthenticationService } from 'src/app/services/authentication/authentication.service';

import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-opportunities',
  templateUrl: './opportunities.component.html',
  styleUrls: ['./opportunities.component.scss'],

  providers: [FilterService, ConfirmationService],

})
export class OpportunitiesComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('dt') table: Table;
  @ViewChild('closeOpportunity') closeOpportunity: CloseOpportunityComponent;

  opportunityDataRows: OpportunityDataRow[] = new Array();

  cols = [];

  // Initially selected columns
  filteredColumns = [];
  selectedColumns = [];
  filters = {};



  filterForPage = 'opportunities';
  filterIsToggled = true;

  sectorList: sectorslist[];
  statusList: statuslist[] = new Array();
  categoryList: Categorieslist[];

  opportunityNameList: any[] = new Array();
  customerNameList: any[] = new Array();
  sourceList: Source[] = [];
  msgs: Message[] = [];

  canDelete: boolean;
  hasSTG: boolean;
  hasSWG: boolean;
  hasTechLeadAccess: boolean;

  sectorFilter: string = 'All';
  sbmchannelFilter: string = "All";
  statusFilter: string = 'All';
  public quarterFilter: string[] = ['null'];
  public monthsFilter: string[] = ['null'];
  public yearFilter: string[] = [new Date().getFullYear() + ''];
  public renewableFilter: boolean = false;
  gstatusFilter: string = 'All';
  customersFilter: string = 'All';
  opportunitiesNameFilter: string = 'All';
  ownersNameFilter: string = 'All';
  partnerFilter: boolean = false;

  groupNameFilter: string = 'All';
  opportunityNameFilter: String = 'All';

  displayProductKindCheckBoxes = false;
  public currentLoggedUserList: Users[];
  public currentLoggedUser: Users;

  sectorDropdown: any[] = new Array();
  statusDropdown: any[] = new Array();
  typeDropdown: any[] = new Array();
  preFilterParams: string[];

  displayEditDialog: boolean = false;
  showEditBtn: boolean = true;

  from = 0;
  to = 0;

  serviceFilter = { from: null, to: null };
  stgFilter = { from: null, to: null };
  swgFilter = { from: null, to: null };
  sssFilter = { from: null, to: null };



  // dialog filter component
  displayFilterDialog: boolean = false;
  currentFilter: { from: number; to: number } = { from: null, to: null };
  dialogTitle: string = '';
  currentDialogType: string = '';


  // dialog text-filter component
  displayTextFilter: boolean = false;
  textDialogData: String = '';
  textDialogType: String = '';
  textDialogTitle: String = '';
  textDialogPlaceholder: String = '';



  // dialog DropDown-filter component
  displayDropDownFilterDialog: boolean = false;
  dropDownfilterTitle: string = '';
  dropDownfilterType: string = '';
  dropDownfilterList: any[] = new Array();
  statusSelectedDropDown: string = '';
  typeSelectedDropDown: string = '';
  leadNameSelectedDropDown: string = '';
  dropdownfilterSelect: string = '';
  dropDownfilterPlaceHolder: string = '';
  techLeadNameFilterList: any[] = new Array();


  // filter is active or not

  yearFilterIsActive: boolean = true;
  quarterFilterIsActive: boolean = false;
  monthFilterIsActive: boolean = false;
  customerFilterIsActive: boolean = false;
  groupFilterIsActive: boolean = false;
  opportunityFilterIsActive: boolean = false;
  SSSfilterIsActive: boolean = false;
  SWGFilterIsActive: boolean = false;
  STGFilterIsActive: boolean = false;
  SERVICEFilterIsActive: boolean = false;
  OwnerFilterIsActive: boolean = false;
  techLeadFilterIsActive: boolean = false;
  statusFilterIsAction: boolean = false;
  typeFilterIsAction: boolean = false;

  // filter values
  yearOptions: any[] = [];
  selectedYears: number[] = [];
  quarterOptions: any[] = [];

  monthOptions: any[] = [];


  // in angular 11
  customRangeFilter: (value: any, filter: any) => boolean;
  public accessLevelEnum = AccessLevelEnum;



  // new table


  constructor(
    private OpportunitiesService: OpportunitiesService, private router: Router,
    private sectorsService: SectorsService, private statusService: StatusService,
    private categoriesService: CategoriesService, private confirmationService: ConfirmationService,
    private salesService: SalesService, private sourceService: SourceService,
    private route: ActivatedRoute, private filterService: FilterService,
    public authenticationService: AuthenticationService,
    private cookieService: CookieService,
    private ngZone: NgZone) {
    this.setupCustomFilters();
  }


  // Custom filter setup angular 11
  setupCustomFilters() {




    this.customRangeFilter = (value: any, filter: any): boolean => {
      const from = filter.from;
      const to = filter.to;
      const val = parseFloat(value); // Assuming value is a numeric string or number

      // Only apply filter conditions if either from or to is specified
      if (from !== null || to !== null) {
        if (from === null && to !== null) {
          return val <= to;
        } else if (from !== null && to === null) {
          return val >= from;
        } else {
          return val >= from && val <= to;
        }
      }

      // If both from and to are null, no filtering is applied
      return true;
    };
  }



  // cookie service

  loadSelectedColumns() {
    const savedColumns = this.cookieService.get('selectedColumns');

    if (savedColumns) {
      try {
        const parsedColumns = JSON.parse(savedColumns);
        this.selectedColumns = parsedColumns.filter(savedCol =>
          this.cols.some(col => col.field === savedCol.field)
        );
      } catch (error) {
        console.error('Error parsing saved columns', error);
        this.selectedColumns = this.getDefaultColumns();
      }
    } else {
      this.selectedColumns = this.getDefaultColumns();
    }
  }

  getDefaultColumns() {

    return this.cols.slice(0, 12);
  }

  saveSelectedColumns() {
    try {

      this.cookieService.set(
        'selectedColumns',
        JSON.stringify(this.selectedColumns),
        { expires: 300, path: '/' }
      );
    } catch (error) {
      console.error('Error saving columns to cookie', error);
    }
  }

  onColumnSelect() {
    this.saveSelectedColumns();
  }

  onColReorder(event: any) {
    this.saveSelectedColumns();
  }


  // for year filter 


  generateYearOptions() {
    const currentYear = new Date().getFullYear();

    for (let year = 1990; year <= 2050; year++) {
      this.yearOptions.push({
        label: year.toString(),
        value: year.toString()
      });
    }
  }

  loadQuarters() {
    this.quarterOptions = [{ label: 'Q1', value: 'Q1' }, { label: 'Q2', value: 'Q2' }
      , { label: 'Q3', value: 'Q3' }, { label: 'Q4', value: 'Q4' }];
  }

  loadMonths() {
    this.monthOptions = [{ label: 'M1', value: 'M1' }, { label: 'M2', value: 'M2' }, { label: 'M3', value: 'M3' }];
  }


  // for cacheing the filter



  /////////////////////////////////////////////

  openFilterDialog(dialogType: string) {
    this.currentDialogType = dialogType;
    this.dialogTitle = `Filter ${dialogType} Range`;
    // console.log("the dialog for: ", dialogType);
    switch (dialogType) {
      case 'SSS':
        this.currentFilter = { from: this.sssFilter.from, to: this.sssFilter.to };
        break;
      case 'SWG':
        this.currentFilter = { from: this.swgFilter.from, to: this.swgFilter.to };
        break;
      case 'STG':
        this.currentFilter = { from: this.stgFilter.from, to: this.stgFilter.to };
        break;
      case 'SERVICE':
        this.currentFilter = { from: this.serviceFilter.from, to: this.serviceFilter.to };
        break;
    }
    this.displayFilterDialog = true;
  }


  onFilterReset(dialogType: string) {
    // console.log('Filter reset for dialog type:', dialogType);
    // Handle reset logic based on the dialog type
    switch (dialogType) {
      case 'SSS':
        this.SSSfilterIsActive = false;
        this.reset_SSS_Filter();
        break;
      case 'SWG':
        this.SWGFilterIsActive = false;
        this.reset_SWG_Filter();
        break;
      case 'STG':
        this.STGFilterIsActive = false;
        this.reset_STG_Filter();
        break;
      case 'SERVICE':
        this.SERVICEFilterIsActive = false;
        this.reset_SERVICE_Filter();
        break
    }
    this.displayFilterDialog = false;
  }

  onFilterApplied(event: { from: number; to: number; type: string }) {
    // console.log('Filter applied for dialog type:', event.type, 'with values:', event);
    // Handle apply filter logic based on the dialog type
    switch (event.type) {
      case 'SSS':

        this.SSSfilterIsActive = event.from == 0 && event.to == 9000000 ? false : true;

        this.sssFilter = { from: event.from, to: event.to };
        this.applySSSRangeFilter();
        break;
      case 'SWG':
        this.SWGFilterIsActive = event.from == 0 && event.to == 9000000 ? false : true;
        this.swgFilter = { from: event.from, to: event.to };
        this.applySWGRangeFilter();
        break;
      case 'STG':
        this.STGFilterIsActive = event.from == 0 && event.to == 9000000 ? false : true;
        this.stgFilter = { from: event.from, to: event.to };
        this.applySTGRangeFilter();
        break;
      case 'SERVICE':
        this.SERVICEFilterIsActive = event.from == 0 && event.to == 9000000 ? false : true;
        this.serviceFilter = { from: event.from, to: event.to };
        this.applyCustomRangeFilter();
        break;
    }
    this.displayFilterDialog = false;
  }




  // reset SSSFilter
  reset_SSS_Filter() {
    this.sssFilter.from = null;
    this.sssFilter.to = null;
    this.applySSSRangeFilter();
  }

  // reset SWGFilter
  reset_SWG_Filter() {
    this.swgFilter.from = null;
    this.swgFilter.to = null;
    this.applySWGRangeFilter();
  }

  // reset STGFilter
  reset_STG_Filter() {
    this.stgFilter.from = null;
    this.stgFilter.to = null;
    this.applySTGRangeFilter();
  }

  // reset SERVICEFilter
  reset_SERVICE_Filter() {
    this.serviceFilter.from = null;
    this.serviceFilter.to = null;
    this.applyCustomRangeFilter();
  }



  // Apply custom range filter for 'service' column
  applyCustomRangeFilter() {
    // console.log('Service Filter:', this.serviceFilter);

    // Filter only if at least one of from or to is set
    if (this.serviceFilter.from !== null || this.serviceFilter.to !== null) {
      this.table.filter(this.serviceFilter, 'service', 'customRangeFilter');
    } else {
      // Clear filter if both from and to are null
      this.table.filter(null, 'service', null);
    }



  }

  applySWGRangeFilter() {
    // console.log('SWG Filter:', this.swgFilter);

    if (this.swgFilter.from !== null || this.swgFilter.to !== null) {
      this.table.filter(this.swgFilter, 'swg', 'customRangeFilter');
    } else {
      this.table.filter(null, 'swg', null);
    }

  }

  applySTGRangeFilter() {
    // console.log('STG Filter:', this.stgFilter);

    if (this.stgFilter.from !== null || this.stgFilter.to !== null) {
      this.table.filter(this.stgFilter, 'stg', 'customRangeFilter');
    } else {
      this.table.filter(null, 'stg', null);
    }


  }

  applySSSRangeFilter() {
    // console.log('SSS Filter:', this.sssFilter);

    // Apply filter only if at least one of the 'from' or 'to' values is set
    if (this.sssFilter.from !== null || this.sssFilter.to !== null) {
      this.table.filter(this.sssFilter, 'sss', 'customRangeFilter');
    } else {
      // Clear the filter if both 'from' and 'to' values are null
      this.table.filter(null, 'sss', null);
    }

  }


  // textDialog filter
  openTextFilterDialog(type: String) {
    this.textDialogType = type;
    // console.log("the dialog text for : " + type + " Opening");
    switch (type) {
      case 'YEAR':
        this.textDialogData = this.yearFilter[0];
        this.textDialogPlaceholder = "Search by year";
        this.textDialogTitle = "Enter Year:"
        this.textDialogType = type;
        break;
      case 'QUARTER':
        this.textDialogData = this.quarterFilter[0] == 'null' ? '' : this.quarterFilter[0];
        this.textDialogPlaceholder = "Search by Quarter"
        this.textDialogTitle = "Enter Quarter:"
        this.textDialogType = type;
        break;
      case 'MONTH':
        this.textDialogData = this.monthsFilter[0] == 'null' ? '' : this.monthsFilter[0];
        this.textDialogPlaceholder = "Search by Month";
        this.textDialogTitle = "Enter Month:"
        this.textDialogType = type;
        break;
      case 'CUSTOMER':
        this.textDialogData = this.customersFilter == 'All' ? '' : this.customersFilter;
        this.textDialogPlaceholder = "Search by Customer Name";
        this.textDialogTitle = "Enter Customer Name:"
        this.textDialogType = type;
        break;
      case 'GROUP':
        this.textDialogData = this.groupNameFilter == 'All' ? '' : this.groupNameFilter;
        this.textDialogPlaceholder = "Search by Group Name";
        this.textDialogTitle = "Enter Group Name:"
        this.textDialogType = type;
        break;
      case 'OPPORTUNITY':
        this.textDialogData = this.opportunityNameFilter == 'All' ? '' : this.opportunityNameFilter;
        this.textDialogPlaceholder = "Search by Opportunity Name";
        this.textDialogTitle = "Enter Opportunity Name:"
        this.textDialogType = type;
        break;

      case 'OWNER':
        this.textDialogData = this.ownersNameFilter == 'All' ? '' : this.ownersNameFilter;
        this.textDialogPlaceholder = "Search by Owner Name";
        this.textDialogTitle = "Enter Owner Name:"
        this.textDialogType = type;
        break;


    }


    this.displayTextFilter = true;
  }

  onFilterTextReset(type: String) {

    switch (type) {
      case 'YEAR':
        this.yearFilter = [new Date().getFullYear() + ''];
        this.table.filter('', 'year', 'contains');
        this.yearFilterIsActive = false;
        break;
      case 'QUARTER':
        this.quarterFilter = ['null'];
        this.table.filter('', 'quarter', 'contains');
        this.quarterFilterIsActive = false;
        break;
      case 'MONTH':
        this.monthsFilter = ['null'];
        this.table.filter('', 'month', 'contains')
        this.monthFilterIsActive = false;
        break;
      case 'CUSTOMER':
        this.customersFilter = 'All';
        this.table.filter('', 'customer', 'contains')
        this.customerFilterIsActive = false;
        break;
      case 'GROUP':
        this.groupNameFilter = 'All';
        this.table.filter('', 'customerGroupName', 'contains')
        this.groupFilterIsActive = false;
        break;

      case 'OPPORTUNITY':
        this.opportunitiesNameFilter = 'All';
        this.table.filter('', 'opportunityName', 'contains')
        this.opportunityFilterIsActive = false;
        break;
      case 'OWNER':
        this.ownersNameFilter = 'All';
        this.table.filter('', 'sssOwnerName', 'contains')
        this.OwnerFilterIsActive = false;
        break;

    }

    this.displayTextFilter = false;

  }

  onFilterTextApplied(event: { data: string, type: string }) {

    switch (event.type) {
      case 'YEAR':
        this.yearFilter = [event.data + '']
        this.table.filter(event.data, 'year', 'contains')
        this.yearFilterIsActive = event.data == '' ? false : true;
        break;
      case "QUARTER":
        this.quarterFilter = [event.data + ''];
        this.table.filter(event.data, 'quarter', 'contains');
        this.quarterFilterIsActive = event.data == '' ? false : true;
        break;
      case 'MONTH':
        this.monthsFilter = [event.data + ''];
        this.table.filter(event.data, 'month', 'contains');
        this.monthFilterIsActive = event.data == '' ? false : true;
        break;
      case 'CUSTOMER':
        this.customersFilter = event.data;
        this.table.filter(event.data, 'customer', 'contains');
        this.customerFilterIsActive = event.data == '' ? false : true;
        break;
      case 'GROUP':
        this.groupNameFilter = event.data;
        this.table.filter(event.data, 'customerGroupName', 'contains')
        this.groupFilterIsActive = event.data == '' ? false : true;
        break;
      case 'OPPORTUNITY':
        this.opportunitiesNameFilter = event.data;
        this.table.filter(event.data, 'opportunityName', 'contains')
        this.opportunityFilterIsActive = event.data == '' ? false : true;
        break;
      case 'OWNER':
        this.ownersNameFilter = event.data;
        this.table.filter(event.data, 'sssOwnerName', 'contains')
        this.OwnerFilterIsActive = event.data == '' ? false : true;
        break;



    }
    this.displayTextFilter = false;
  }

  // dropDown-filter

  openDropDownFilterDialog(type: string) {

    // console.log("List of Lead" + this.techLeadNameFilterList);
    switch (type) {
      case 'TYPE':
        this.dropDownfilterList = this.typeDropdown;
        this.dropdownfilterSelect = this.typeSelectedDropDown;
        this.dropDownfilterPlaceHolder = "Search by Type";
        this.dropDownfilterTitle = "Select Type: ";
        this.dropDownfilterType = type;
        break;
      case 'STATUS':
        this.dropDownfilterList = this.statusDropdown;
        this.dropdownfilterSelect = this.statusSelectedDropDown;
        this.dropDownfilterPlaceHolder = "Search by Status";
        this.dropDownfilterTitle = "Select Status: ";
        this.dropDownfilterType = type;
        break;
      case 'LEAD':
        this.dropDownfilterList = this.techLeadNameFilterList;
        this.dropdownfilterSelect = this.leadNameSelectedDropDown;
        this.dropDownfilterPlaceHolder = "Search by Lead Name";
        this.dropDownfilterTitle = "Select Technical Lead Name: ";
        this.dropDownfilterType = type;


    }

    this.displayDropDownFilterDialog = true;

  }

  onFilterDropDownReset(type: string) {

    switch (type) {
      case 'TYPE':
        this.table.filter('', 'type', 'contains')
        this.typeSelectedDropDown = null;
        this.typeFilterIsAction = false;
        break;
      case 'STATUS':
        this.table.filter('', 'status', 'contains')
        this.statusSelectedDropDown = null;
        this.statusFilterIsAction = false;
        break;
      case 'LEAD':
        this.table.filter('', 'techLeadName', 'contains')
        this.leadNameSelectedDropDown = null;
        this.techLeadFilterIsActive = false;
        break;
    }

    this.displayDropDownFilterDialog = false;
  }

  onFilterDropDownApplied(event: { data: string, type: string }) {

    switch (event.type) {
      case 'TYPE':
        this.typeSelectedDropDown = event.data;
        this.table.filter(event.data, 'type', 'contains')
        this.typeFilterIsAction = event.data == null ? false : true;
        break;
      case 'STATUS':
        this.statusSelectedDropDown = event.data;
        this.table.filter(event.data, 'status', 'contains')
        this.statusFilterIsAction = event.data == null ? false : true;
        break;
      case 'LEAD':
        this.leadNameSelectedDropDown = event.data;
        this.table.filter(event.data, 'techLeadName', 'contains')
        this.techLeadFilterIsActive = event.data == null ? false : true;
    }

    this.displayDropDownFilterDialog = false;
  }


  // temperare Fixed for bug 

  sortField :any ;
  sortOrder : any;
  removeSortStateFromTable() {

    const storage = window.localStorage;
    const stateString = storage.getItem('Filters');
    if (stateString) {
      const dateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
      const reviver = function (key: any, value: any) {
        if (typeof value === 'string' && dateFormat.test(value)) {
          return new Date(value);
        }

        return value;
      };



      let state: TableState = JSON.parse(stateString, reviver);
      this.sortField = state.sortField;
      this.sortOrder = state.sortOrder;
      delete state.sortField;
      delete state.columnWidths;
      delete state.tableWidth ;
      

      storage.setItem("Filters", JSON.stringify(state));

    }
  }



  async ngOnInit() {


    this.removeSortStateFromTable();

    this.generateYearOptions();
    this.loadQuarters();
    this.loadMonths();

  





    this.filterService.register('myCustomFilter', (value: any, filter: any): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return value.toString() != filter.toString();
    });


    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    $("body").css("overflow-y", "hidden");

    this.route.params.subscribe(params => {
      this.preFilterParams = new Array();
      if (params['filter'] != undefined) {
        this.preFilterParams.push(params['filter']);
        if (this.preFilterParams[0] == 'Closed') {
          this.preFilterParams.push('Lost');
          this.preFilterParams.push('Canceled');
        }
      }
    });

    await this.loadLists();
    await this.fillLeadsData();


    //this.onResetClick(null);
    // Spinner
    $(".spinner-container").fadeOut();
    $("body").css("overflow-y", "auto");
    //$(".table").attr("title","Double Click Row for details!!!");



    // this.filters = {};



    await this.applyFilters();

    this.cols = [
      { field: 'opportunityName', header: 'Opp Name', width: 5, filterType: 'text', condition: true },
      { field: 'customer', header: 'Customer', width: 5, filterType: 'text', condition: true },
      { field: 'sssOwnerName', header: 'Owner Name', width: 10, filterType: 'text', condition: true },
      { field: 'creationDate', header: 'Creation Date', width: 10, filterType: 'date', condition: true },
      { field: 'year', header: 'Year', width: 8, filterType: 'date', condition: true },
      { field: 'quarter', header: 'Q', width: 6, filterType: 'quarter', condition: true },
      { field: 'month', header: 'M', width: 6, filterType: 'month', condition: true },
      { field: 'status', header: 'Status', width: 10, filterType: 'dropdown', options: this.statusDropdown, condition: true },
      { field: 'type', header: 'Odds', width: 7, filterType: 'dropdown', options: this.typeDropdown, condition: true },
      { field: 'customerGroupName', header: 'Group', width: 11, filterType: 'text', condition: true },
      { field: 'sector', header: 'Sector', width: 11, filterType: 'dropdown', options: this.sectorDropdown, condition: true },
      { field: 'sss', header: 'SSS', width: 9, filterType: 'numeric', condition: true },
      { field: 'swg', header: 'S/W Lic', width: 9, filterType: 'numeric', condition: this.hasSWG },
      { field: 'stg', header: 'STG', width: 9, filterType: 'numeric', condition: this.hasSTG },
      { field: 'service', header: 'S/W Services', width: 10, filterType: 'numeric', condition: true },
      { field: 'techLeadName', header: 'Technical Lead', width: 10, filterType: 'dropdown', options: this.techLeadNameFilterList, condition: this.hasTechLeadAccess },

    ];

    // Initialize selectedColumns based on initial conditions
    this.selectedColumns = this.cols.filter(col => col.condition);

    // Filtered columns for column toggle dropdown
    this.filteredColumns = this.cols.filter(col => col.condition);


    this.loadSelectedColumns();






  }

  ngAfterViewInit() {

    this.table.restoreState();
  }



  ngOnDestroy(): void {

    // this.saveFiltersToCookies(this.filters);
  }

  async applyFilters() {

    let filters = this.OpportunitiesService.getFilters();
    //filters.productKind
    // console.log(filters);
    if (filters.renewable) {
      // console.log('applying renewable filter');
      this.renewableFilter = true;
      this.table.filter(filters.renewable, 'renewable', 'equals');
    }
    if (filters.partner) {
      // console.log('applying partner filter');
      this.partnerFilter = true;
      this.table.filter(1, 'sourceId', 'equals');
    }
    if (filters.year != undefined && filters.year != null) {
      // console.log("this.yearFilter : " + filters.year);
      // console.log('applying year filter');
      this.table.filter(filters.year, 'year', 'in');
    }
    if (filters.quarter != undefined && filters.quarter != null) {
      // console.log("this.filters.quarter : " + filters.quarter);
      let quarterTableFilter = [];
      for (let index = 0; index < filters.quarter.length; index++) {
        const element = filters.quarter[index];
        if (element != null && element != 'null') {
          quarterTableFilter.push('Q' + element);
        }
      }
      // console.log('quarterTableFilter : ' + quarterTableFilter);
      if (quarterTableFilter.length > 0) {
        // console.log('applying quarter filter');
        this.table.filter(quarterTableFilter, 'quarter', 'in');
      }
    }

    if (filters.month != undefined && filters.month != null) {

      let monthTableFilter = [];
      for (let index = 0; index < filters.month.length; index++) {
        const element = filters.month[index];
        if (element != null && element != 'null') {
          monthTableFilter.push('M' + element);
        }
      }
      // console.log('monthTableFilter : ' + monthTableFilter);
      if (monthTableFilter.length > 0) {
        // console.log('applying month filter');
        this.table.filter(monthTableFilter, 'month', 'in');
      }
    }
    if (filters.gstatus != undefined && filters.gstatus != null) {
      // console.log('applying gstatus filter');
      this.doStatusFilter(filters.gstatus);
    }

    if (filters.sbmchannel != undefined && filters.sbmchannel != null) {

      if (filters.sbmchannel == 'All') {
        this.sbmchannelFilter = filters.sbmchannel;
        // console.log('applying sbmChannel filter');
        this.table.filter(null, 'sbmChannel', 'equals')
      } else {
        this.sbmchannelFilter = filters.sbmchannel;
        this.sbmchannelFilter = this.sbmchannelFilter.replace("-", " ");
        // console.log(this.sbmchannelFilter);
        // console.log('applying sbmChannel filter');
        //console.log(selectedText);
        this.table.filter(this.sbmchannelFilter, 'sbmChannel', 'equals')
      }
    }

    if (filters.status != undefined && filters.status != null) {
      this.statusFilter = filters.status;
      // console.log("status : " + this.statusFilter);
      if (filters.status == 'All') {
        // console.log('applying status filter');
        this.table.filter(null, 'status', 'equals')
      } else {
        // console.log('applying statusid filter');
        this.table.filter(this.statusFilter, 'statusId', 'equals')
      }
    }

    if (filters.sector != undefined && filters.sector != null) {
      if (filters.sector == 'All') {
        this.sectorFilter = filters.sector;
        // console.log('applying sector filter');
        this.table.filter(null, 'sector', 'equals')
      } else {
        this.sectorFilter = filters.sector;
        // console.log('applying sector filter');
        this.table.filter(filters.sector, 'sectorId', 'equals')
      }
    }

    if (filters.customersFilter != undefined && filters.customersFilter != null) {

      if (filters.customersFilter != 'All') {
        // console.log('applying customersFilter filter');
        this.table.filter(filters.customersFilter, 'customerId', 'equals');
      }
    }
    if (filters.opportunitiesNameFilter != undefined && filters.opportunitiesNameFilter != null) {
      if (filters.opportunitiesNameFilter != 'All') {
        // console.log('applying opportunityName filter');
        this.table.filter(filters.opportunitiesNameFilter, 'opportunityName', 'equals');
      }
    }
    if (filters.ownersNameFilter != undefined && filters.ownersNameFilter != null) {
      if (filters.ownersNameFilter != 'All') {
        // console.log('applying ownersName Filter ');
        this.table.filter(filters.ownersNameFilter, 'sssOwnersName', 'equals');
      }
    }



  }






  async loadLists() {
    let useremail = sessionStorage.getItem('loginUserName');
    await this.sectorsService.getsectorsList().toPromise().then(response => {
      this.sectorList = response;
      for (let index = 0; index < this.sectorList.length; index++) {
        const element = this.sectorList[index];
        this.sectorDropdown.push({ label: element.sector, value: element.sector });
      }
    });
    await this.statusService.getstatusList().toPromise().then((response: statuslist[]) => {
      for (let index = 0; index < response.length; index++) {
        if (this.preFilterParams.length != 0 && !this.preFilterParams.includes(response[index].status)) {
          continue;
        }
        const element = response[index];
        this.statusList.push(element);
        this.statusDropdown.push({ label: element.status, value: element.status });
        this.typeDropdown.push({ label: element.odds, value: element.odds });
      }

    });
    await this.OpportunitiesService.hasSWGOpportunityPermission().toPromise().then(response => {
      this.hasSWG = response;
      // console.log("SWG", this.hasSWG)
    });
    await this.OpportunitiesService.hasSTGOpportunityPermission().toPromise().then(response => {
      this.hasSTG = response;
      // console.log("STG", this.hasSTG)
    });
    await this.categoriesService.getCategoriesList().toPromise().then(response => { this.categoryList = response; });
    await this.OpportunitiesService.hasDeleteOpportunityPermission().toPromise().then(response => { this.canDelete = response; });
    await this.sourceService.getSourceList().toPromise().then(
      response => {
        //////console.log("retrieveSourceList : "+ response);
        //////console.log(response);
        this.sourceList = response;

      }
    );

    await this.salesService.findUserByEmail(useremail).toPromise().then(
      response => {
        //console.log("getCurrentLoggedUser : "+ response);
        //console.log(response);
        this.currentLoggedUserList = response;
        this.currentLoggedUser = this.currentLoggedUserList[0];
        this.hasTechLeadAccess = this.currentLoggedUser.role.techLeadAccess || useremail == 'tkhattab@sbm.com.sa';

        if (this.currentLoggedUser.role.roleId == 12 || this.currentLoggedUser.role.roleId == 13) {
          this.displayProductKindCheckBoxes = true;
        }
        // console.log("displayProductKindCheckBoxes : " + this.displayProductKindCheckBoxes);
        //console.log( this.currentLoggedUser );
      }
    );

    await this.salesService.retrieveTechLeads().toPromise().then(response => {
      this.techLeadNameFilterList = response.map(user => ({
        label: user.firstName + " " + user.lastName,
        value: user.firstName + " " + user.lastName
      }));
    });




  }

  async fillLeadsData() {//region: string, sales: string, sector: string, status: string, year: string, quarter: any, productKind: string, gstatus: string) {
    
    return this.OpportunitiesService.retriveLeadsDataList(/*region, sales , sector , status , year, quarter , productKind , gstatus*/).subscribe(
      response => {
        // console.log(response);
        response.forEach(oppData => {
          //console.log(oppData);
          let opportunityrow = new OpportunityDataRow();
          let oppDate = new Date(oppData.closingDate);
          // debugger;
          opportunityrow.quarter = 'Q' + Math.floor((oppDate.getMonth() + 3) / 3);
          opportunityrow.month = geMonthNumber(oppDate.getMonth() + 1);
          opportunityrow.year = oppDate.getFullYear().toString();
          opportunityrow.opportunityName = oppData.opportunityName;
          opportunityrow.opportunityId = oppData.opportunityId;
          opportunityrow.customer = oppData.customerName;
          opportunityrow.customerId = oppData.customerId;
          opportunityrow.sbmChannel = oppData.sbmchannel;
          opportunityrow.renewable = oppData.renewable;
          opportunityrow.sourceId = oppData.sourceId;
          opportunityrow.sourceId = oppData.sourceId;
          opportunityrow.attachCount = oppData.attachCount;
          opportunityrow.sssOwnerName = oppData.sssOwnerName;
          opportunityrow.techLeadName = oppData.techLeadName;
          opportunityrow.sector = oppData.sector;
          opportunityrow.customerGroupName = oppData.customerGroupName;
          console.log(" CreationDate: " , oppData.creationDate);
          // opportunityrow.creationDate = oppData.creationDate;
          opportunityrow.creationDate = new Date(oppData.creationDate);
          console.log(" CreationDate: " , opportunityrow.creationDate);
          prepareStatusValues(oppData.statusId, this.statusList, opportunityrow);
          prepareSectorValues(oppData.sectorId, this.sectorList, opportunityrow);
          prepareOrderValues(oppData.order, this.categoryList, opportunityrow);
          // console.log(opportunityrow.productKind);
          opportunityrow.productKind = Array.from(new Set(opportunityrow.productKind));
          // console.log(opportunityrow.productKind);
          this.prepareFilterLists(opportunityrow);
          this.opportunityDataRows.push(opportunityrow);
        });
        this.applyFilters();

        
        
        if (this.sortField) {
          this.table.restoringSort = true;
          this.table.sortField = this.sortField;
          this.table.sortOrder = <number>this.sortOrder;
          this.table.sortSingle();    
        }
        

      }
    );
  }

  prepareFilterLists(opportunityrow) {
    var target = this.opportunityNameList.find(temp => temp.label == opportunityrow.opportunityName);
    if (!target) {
      this.opportunityNameList.push({ label: opportunityrow.opportunityName, value: opportunityrow.opportunityName, id: opportunityrow.opportunityId });
    }

    var target = this.customerNameList.find(temp => temp.label == opportunityrow.customer);
    if (!target) {

      // console.log("name: " + opportunityrow.customer + "  id: " + opportunityrow.customerId);

      this.customerNameList.push({ label: opportunityrow.customer, value: opportunityrow.customer, id: opportunityrow.customerId });
    }
  }

  doStatusFilter(value: string) {
    this.gstatusFilter = value;
    if (value == 'Active') {
      //this.gstatusFilter = '0';
      var actStat = [1, 2, 3, 4];
      this.table.filter(actStat, 'statusId', 'in')
      // this.table.filter("Prospecting, Won", 'status', 'in');
    } else if (value == 'InActive') {
      //this.gstatusFilter = '1';
      var actStat = [5, 6, 7, 8];
      this.table.filter(actStat, 'statusId', 'in')
    } else {
      //this.gstatusFilter = 'All';
      var actStat = [1, 2, 3, 4, 5, 6, 7, 8];
      this.table.filter(actStat, 'statusId', 'in')
    }
  }

  public onDropDownClicked(event: any) {


    if (event.elementType != undefined) {

      if (event.elementType == "genericstatus") {
        this.doStatusFilter(event.target.value);
      }
      if (event.elementType == "sbmchannel") {
        let selectedText = event.target['options']
        [event.target['options'].selectedIndex].text;
        if (selectedText == 'All') {
          this.sbmchannelFilter = selectedText;
          this.table.filter(null, 'sbmChannel', 'equals')
        } else {
          this.sbmchannelFilter = event.target.value;
          this.sbmchannelFilter = this.sbmchannelFilter.replace("-", " ");
          // console.log(this.sbmchannelFilter);
          // console.log(selectedText);
          this.table.filter(selectedText, 'sbmChannel', 'equals')
        }
      }

      if (event.elementType == "status") {
        let selectedText = event.target['options']
        [event.target['options'].selectedIndex].text;
        if (selectedText == 'All') {
          this.statusFilter = selectedText;
          this.table.filter(null, 'status', 'equals')
        } else {
          this.statusFilter = event.target.value;
          // console.log(this.statusFilter);
          // console.log(selectedText);
          this.table.filter(selectedText, 'status', 'equals')
        }
        // event.value==null?
        // this.table.filter(event.value, 'status', 'equals') : this.table.filter(event.value.status, 'status', 'equals')
      }
      if (event.elementType == "sector") {
        let selectedText = event.target['options']
        [event.target['options'].selectedIndex].text;
        if (selectedText == 'All') {
          this.sectorFilter = selectedText;
          this.table.filter(null, 'sector', 'equals')
        } else {
          this.sectorFilter = event.target.value;
          this.table.filter(selectedText, 'sector', 'equals')
        }

        // event.value==null?
        // this.table.filter(event.value, 'sector', 'equals') : this.table.filter(event.value.sector, 'sector', 'equals');
      }
      if (event.elementType == "customers") {

        this.customersFilter = event.value == null ? 'All' : event.originalEvent.target.id;

        this.OpportunitiesService.filters.customersFilter = this.customersFilter;
        this.table.filter(event.value, 'customer', 'equals');
      }
      if (event.elementType == "opportunities") {
        // console.log(event.originalEvent.target.id)
        this.opportunitiesNameFilter = event.value == null ? 'All' : event.originalEvent.target.id;

        this.OpportunitiesService.filters.opportunitiesNameFilter = this.opportunitiesNameFilter;
        this.table.filter(event.value, 'opportunityName', 'equals');
      }
      if (event.elementType == "owners") {
        // console.log(event.originalEvent.target.id)
        this.ownersNameFilter = event.value == null ? 'All' : event.value;
        this.table.filter(event.value, 'sssOwnersName', 'equals');
      }
    }



    this.OpportunitiesService.setFilters(this.monthsFilter, null, null, this.sectorFilter, this.statusFilter, this.yearFilter, this.quarterFilter, null, this.gstatusFilter, this.renewableFilter, this.sbmchannelFilter, this.customersFilter, this.opportunitiesNameFilter, this.partnerFilter, this.ownersNameFilter);

  }

  public onCheckBoxClicked(event: any) {


    // console.log("event :" + event);
    // console.log(event.target.id);
    if (event.target.id.includes("renewable")) {

      var yearul = <HTMLInputElement>document.getElementById("renewableul");
      var inputs = yearul.getElementsByTagName("input");
      this.renewableFilter = false;
      for (let index = 0; index < inputs.length; index++) {
        const element = inputs[index];
        if (element.checked) {
          this.renewableFilter = true;
        }
      }
      this.table.filter(this.renewableFilter, 'renewable', 'equals');
    }
    else if (event.target.id.includes("partner")) {

      // console.log("partner checkbox changed......");
      var yearul = <HTMLInputElement>document.getElementById("partnerul");
      var inputs = yearul.getElementsByTagName("input");
      this.partnerFilter = false;
      for (let index = 0; index < inputs.length; index++) {
        const element = inputs[index];
        if (element.checked) {

          // console.log("partner is checked true....");
          this.partnerFilter = true;
          this.table.filter(1, 'sourceId', 'equals');
        }
        else {
          let sourceFilter = [];
          for (let index = 0; index < this.sourceList.length; index++) {
            const element = this.sourceList[index];
            sourceFilter.push(element.sourceId);
          }
          this.table.filter(sourceFilter, 'sourceId', 'in');
        }
      }
    }
    else if (event.target.id.includes("year")) {
      var yearul = <HTMLInputElement>document.getElementById("yearul");
      var inputs = yearul.getElementsByTagName("input");
      this.yearFilter = [];
      for (let index = 0; index < inputs.length; index++) {
        const element = inputs[index];
        if (element.checked) {
          this.yearFilter.push(element.value);
        }
      }
      // console.log("this.yearFilter : " + this.yearFilter);
      this.table.filter(this.yearFilter, 'year', 'in');
    }
    else if (event.target.id == "quarter") {
      var quarterul = <HTMLInputElement>document.getElementById("quarter");
      var inputs = quarterul.getElementsByTagName("input");
      this.quarterFilter = [];
      let quarterTableFilter = [];
      for (let index = 0; index < inputs.length; index++) {
        const element = inputs[index];
        if (element.checked) {
          this.quarterFilter.push(element.value);
          quarterTableFilter.push('Q' + element.value);
        }
      }
      //console.log("this.quarterFilter : "+ this.quarterFilter);
      // console.log("this.quarterTableFilter : "+ quarterTableFilter);
      this.table.filter(quarterTableFilter, 'quarter', 'in');
    }
    else if (event.target.id == "month") {
      var yearul = <HTMLInputElement>document.getElementById("month");
      var inputs = yearul.getElementsByTagName("input");
      this.monthsFilter = [];
      let monthTableFilter = [];
      for (let index = 0; index < inputs.length; index++) {
        const element = inputs[index];
        if (element.checked) {
          this.monthsFilter.push(element.value);
          monthTableFilter.push('M' + element.value);
        }
      }
      this.table.filter(monthTableFilter, 'month', 'in');
    }
    else if (event.target.id == "stgType" || event.target.id == "swgType") {

      var stgBox = <HTMLInputElement>document.getElementById("stgType");
      var swgBox = <HTMLInputElement>document.getElementById("swgType");

      var pSWG = false;
      var pSTG = false;

      // console.log(" swg, stg clicked ........");

      if (stgBox.checked) {
        pSTG = true;
      }
      if (swgBox.checked) {
        pSWG = true;
      }

      // console.log(" swg clicked ........" + pSWG);
      // console.log(" stg clicked ........" + pSTG);
      let productKindFilter = [];
      //this.table.reset();
      this.onResetClick(null);
      if (pSWG && pSTG) {

        //this.applyFilters();
        //this.table.filter(this.yearFilter, 'year', 'in');
        this.table.filter("0", "swg", "myCustomFilter");
        this.table.filter("0", "stg", "myCustomFilter");


      }
      else if (!pSWG && pSTG) {
        // productKindFilter.push("STG");
        //this.table.filter(productKindFilter,"productKind","equals");
        this.table.filter("0", "stg", "myCustomFilter");
      }
      else if (pSWG && !pSTG) {
        productKindFilter.push("SWG");
        // console.log(productKindFilter);
        //this.table.filter(productKindFilter,"productKind","equals");
        this.table.filter("0", "swg", "myCustomFilter");
      }
      else {
        productKindFilter.push("SWG");
        productKindFilter.push("STG");
        this.onResetClick(null);
        //this.table.filter(productKindFilter,"productKind","in");
      }
    }
    if (this.yearFilter.length == 0) {

      this.yearFilter.push("All");

    }
    this.OpportunitiesService.setFilters(this.monthsFilter, null, null, this.sectorFilter, this.statusFilter, this.yearFilter, this.quarterFilter, null, this.gstatusFilter, this.renewableFilter, this.sbmchannelFilter, this.customersFilter, this.opportunitiesNameFilter, this.partnerFilter, this.ownersNameFilter);

  }

  public onResetClick(event: any) {
    let currentyear = new Date().getFullYear().toString();

    this.sectorFilter = 'All';
    this.statusFilter = 'All';
    this.quarterFilter = ['null'];
    this.monthsFilter = ['null'];
    this.yearFilter = [currentyear];
    this.sbmchannelFilter = "All";
    this.renewableFilter = false;
    this.gstatusFilter = 'All';
    this.customersFilter = 'All';
    this.opportunitiesNameFilter = 'All';

    this.table.reset();
    this.table.filter(this.yearFilter, 'year', 'in');
    this.filterIsToggled = true;
    this.OpportunitiesService.resetFilters();
  }

  public filterClicked(event: any) {
    this.filterIsToggled = !this.filterIsToggled;
    var element = document.getElementById("leads-table");
    // For IE9
    var classes = element.className.split(" ");
    var i = classes.indexOf("col-md-9");

    if (i >= 0) {
      classes.splice(i, 1);
      classes.push("col-md-12");
    } else {
      classes.splice(i, 1);
      classes.push("col-md-9");
    }
    element.className = classes.join(" ");

  }

  public showHistory(oppId: number) {

    // console.log("Opportunity Id : " + oppId);
    let filter = { id: oppId };
    this.router.navigate(['/history/', oppId], { queryParams: filter, skipLocationChange: true });
    //this.router.navigate(['/history/',  oppId]);
    history.pushState(filter, "", "/history/");

  }

  editOpportunity(opportunityrow) {
    this.displayEditDialog = true;
    this.closeOpportunity.onView(opportunityrow);
  }

  public onDeleteOpportunity(oppId: number) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        if (!this.canDelete) {
          this.showMsg('warning', 'Rejected', 'You don\'t have the permission to delete!!');
        } else {
          this.deleteOpportunity(oppId);
        }
      },
      reject: () => { }
    });
  }

  public deleteOpportunity(oppId: number) {
    this.OpportunitiesService.deleteOpportunity(oppId).subscribe(
      (data) => {
        this.deleteOpprotunityRow(oppId);
        this.showMsg('info', 'Confirmed', 'Record deleted');
      },
      (error) => {
        this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
      });
  }

  public deleteOpprotunityRow(id: number) {
    var index = 0;
    for (var i = 0; this.opportunityDataRows; i++) {
      if (this.opportunityDataRows[i].opportunityId == id) {
        index = i;
        break;
      }
    }
    this.opportunityDataRows = this.opportunityDataRows.slice(0, index).concat(this.opportunityDataRows.slice(index + 1));
  }

  public showMsg(severity: string, summary: string, detail: string) {
    this.msgs = [{ severity: severity, summary: summary, detail: detail }];
    setTimeout(() => { this.msgs = [] }, 2000);
  }








  public onDownloadPDFReport() {


    let data = this.table.filteredValue ? this.table.filteredValue : this.table.value;
    let ids = data.map(item => item.opportunityId);
    // console.log(ids);
    return this.OpportunitiesService.downloadReportByIds("pdf", ids).subscribe(
      (res: Blob) => {
        saveAs(res, 'report.pdf');
      },
      error => {
        console.error('Error downloading file', error);
      }
    );


  }


  // public onDownloadPDFReport() {


  //   let filters = this.OpportunitiesService.getFilters();
  //   return this.OpportunitiesService.downloadReport(filters.sector, filters.status, this.yearFilter, this.quarterFilter,
  //     this.monthsFilter, filters.opportunitiesNameFilter, filters.customersFilter, filters.gstatus, filters.sbmchannel, filters.renewable, 'pdf', filters.partner).subscribe(
  //       res => {
  //         handleDownloadExcel(res);
  //       }
  //     );


  // }




  // public onDownloadExcelReport() {
  //   console.log("Excel downloaded")
  //   console.log("---------------------------------------------------------------------")
  //   // Log each filter value individually for better clarity
  //   let filters = this.OpportunitiesService.getFilters();
  //   console.log("Sector :", filters.sector);
  //   console.log("SBM Channel :", filters.sbmchannel);
  //   console.log("Status :", filters.status);
  //   console.log("Quarter :", filters.quarter);
  //   console.log("Months :", filters.month);
  //   console.log("Year :", filters.year);
  //   console.log("Renewable :", filters.renewable);
  //   console.log("GStatus :", filters.gstatus);
  //   console.log("Customers :", filters.customersFilter);
  //   console.log("Opportunities Name :", filters.opportunitiesNameFilter);
  //   console.log("Partner :", filters.partner);



  //   console.log("---------------------------------------------------------------------")
  //   // return this.OpportunitiesService.downloadReport(this.sector, this.status, this.year, this.quarter,
  //   // this.months, this.opportunitiesName, this.customersName, this.gstatus, this.sbmchannel, this.renewable, 'excel', this.partner).subscribe(
  //   //   res => {
  //   //     handleDownloadExcel(res);
  //   //   }
  //   // );

  //   return this.OpportunitiesService.downloadReport(filters.sector, filters.status, this.yearFilter, this.quarterFilter,
  //     this.monthsFilter, filters.opportunitiesNameFilter, filters.customersFilter, filters.gstatus, filters.sbmchannel, filters.renewable, 'excel', filters.partner).subscribe(
  //       res => {
  //         handleDownloadExcel(res);
  //       }
  //     );
  // }

  public onDownloadExcelReport() {
    //  let id = this.opportunityDataRows.map(item => item.opportunityId);
    let data = this.table.filteredValue ? this.table.filteredValue : this.table.value;
    let ids = data.map(item => item.opportunityId);
    // console.log(ids);
    return this.OpportunitiesService.downloadReportByIds("excel", ids).subscribe(
      (res: Blob) => {
        // console.log(res); // Check the response
        const fileName = 'opportunity_report.xls';
        saveAs(res, fileName);
      },
      error => {
        console.error('Error downloading Excel report', error);
      }
    );


  }

  selectData(rowId: any) {
    let filter = { id: rowId };
    let id = rowId;
    this.router.navigate(['/leads/'], { queryParams: filter, skipLocationChange: true });
    history.pushState(filter, "", "/leads/");
  }




  exportExcel() {
    import("xlsx").then(xlsx => {
      let data = this.table.filteredValue ? this.table.filteredValue : this.table.value;
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "OpportunitiesTable");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }





  exportPdf() {
    const doc = new jsPDF('landscape', 'pt', 'a4');

    const columns = [
      { header: 'Year', dataKey: 'year' },
      { header: 'Quarter', dataKey: 'quarter' },
      { header: 'Month', dataKey: 'month' },
      { header: 'Type', dataKey: 'type' },
      { header: 'Customer', dataKey: 'customer' },
      { header: 'Customer Group', dataKey: 'customerGroup' },
      { header: 'SSS ($)', dataKey: 'sss' },
      { header: 'SWG ($)', dataKey: 'swg' },
      { header: 'STG ($)', dataKey: 'stg' },
      { header: 'Service ($)', dataKey: 'service' },
      { header: 'SSS Owner', dataKey: 'sssOwner' },
      { header: 'Tech Lead', dataKey: 'techLead' }
    ];

    let data = this.table.filteredValue ? this.table.filteredValue : this.table.value;
    const rows = data.map(row => ({
      year: row.year,
      quarter: row.quarter,
      month: row.month,
      type: row.type,
      customer: row.customer,
      customerGroup: row.customerGroupName,
      sss: row.sss?.toLocaleString() ?? '',
      swg: row.swg?.toLocaleString() ?? '',
      stg: row.stg?.toLocaleString() ?? '',
      service: row.service?.toLocaleString() ?? '',
      sssOwner: row.sss,
      techLead: row.techLeadName
    }));

    autoTable(doc, {
      columns: columns,
      body: rows,
      theme: 'grid',
      styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      },
      columnStyles: {
        year: { cellWidth: 30 },
        quarter: { cellWidth: 30 },
        month: { cellWidth: 30 },
        type: { cellWidth: 70 },
        customer: { cellWidth: 120 },
        customerGroup: { cellWidth: 90 },
        sss: { cellWidth: 55, halign: 'right' },
        swg: { cellWidth: 55, halign: 'right' },
        stg: { cellWidth: 50, halign: 'right' },
        service: { cellWidth: 60, halign: 'right' },
        sssOwner: { cellWidth: 60 },
        techLead: { cellWidth: 60 }
      },
      margin: { top: 20 }
    });

    doc.save('opportunities.pdf');
  }



}


function prepareStatusValues(statusId: number, statusList: statuslist[], opportunityrow: OpportunityDataRow) {
  for (var j = 0; j < statusList.length; j++) {
    var option = statusList[j];
    //console.log(option)
    if (option.statusId === statusId) {
      opportunityrow.status = option.status;
      opportunityrow.type = option.odds;
      opportunityrow.statusId = statusId;
      opportunityrow.statusClass = opportunityrow.status.toLowerCase();
      if (opportunityrow.status === 'Prospecting' || opportunityrow.status === 'Validating'
        || opportunityrow.status === 'Qualifying' || opportunityrow.status === 'Negotiating')
        opportunityrow.statusClass = 'active';

      // opportunityrow.statusClass = opportunityrow.status.toLowerCase();
    }
  }
}

function prepareSectorValues(sectorId: number, sectorList: sectorslist[], opportunityrow: OpportunityDataRow) {
  for (var j = 0; j < sectorList.length; j++) {
    var option = sectorList[j];
    if (option.sectorId === sectorId) {
      let sector = option.sector;
      let sectorClass: string;

      if (sector === "Banking")
        sectorClass = 'sector la la-bank';
      else if (sector === "Education")
        sectorClass = 'sector la la-graduation-cap';
      else if (sector === "Public")
        sectorClass = 'sector la la-building';
      else if (sector === "Telco")
        sectorClass = 'sector la la-wifi';
      else if (sector === "Security")
        sectorClass = 'sector la la-user-secret';
      else if (sector === "Eastern Region")
        sectorClass = 'sector la la-angle-double-right';
      else if (sector === "Western Region")
        sectorClass = 'sector la la-angle-double-left';
      else if (sector === "defense")
        sectorClass = 'sector la la-briefcase';
      else
        sectorClass = 'sector la la-' + sector.toLowerCase();

      opportunityrow.sector = sector;
      opportunityrow.sectorId = sectorId;
      opportunityrow.sectorClass = sectorClass;
    }
  }






}

function prepareOrderValues(orders: Opportunities["order"], categoryList: Categorieslist[], opportunityrow: OpportunityDataRow) {
  loop1:
  for (var k = 0; k < orders.length; k++) {
    var x = document.createElement("td");
    var order = orders[k];
    loop2:
    for (var j = 0; j < categoryList.length; j++) {
      var option = categoryList[j];
      if (order.categoryId === option.categoryId && option.category === 'Service') {
        opportunityrow.service = opportunityrow.service + parseInt(order.orderPrice);
        continue loop1;
      }
    }

    if (order.productKind === "SWG") {
      opportunityrow.productKind.push("SWG");
      opportunityrow.swg = opportunityrow.swg + parseInt(order.orderPrice);
      // console.log("swg : "+ swg);
    }
    if (order.productKind === "STG") {
      opportunityrow.productKind.push("STG");
      opportunityrow.stg = opportunityrow.stg + parseInt(order.orderPrice);
      // console.log("stg : "+ stg)
    }
  }
  opportunityrow.sss = opportunityrow.service + opportunityrow.swg + opportunityrow.stg;
}

function geMonthNumber(returned_month: number) {
  if (returned_month == 1 || returned_month == 4 || returned_month == 7 || returned_month == 10) {
    return 'M' + 1
  } else if (returned_month == 2 || returned_month == 5 || returned_month == 8 || returned_month == 11) {
    return 'M' + 2
  } else {
    return 'M' + 3
  }
}

function handleDownloadExcel(res: any) {
  var a = document.createElement("a");
  document.body.appendChild(a);
  var filename = "";
  const contentType = res.headers.get('content-type');
  const disposition = res.headers.get('Content-Disposition')

  if (disposition && disposition.indexOf('attachment') !== -1) {
    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    var matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
  }
  const blob = new Blob([res.blob()], { type: contentType });
  let url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

